module.exports = __webpack_public_path__ + "static/img/9.6aee891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/9.png
// module id = dafC
// module chunks = 0